var map = {
	"./Printer@2x.png": "4d26",
	"./class.png": "831a",
	"./close.png": "c821",
	"./exam.png": "2aa3",
	"./export.png": "058b",
	"./icon-collect.png": "628b",
	"./icon-collected1.png": "4cc9",
	"./icon-dayi.png": "b335",
	"./icon-delete@2x.png": "1902",
	"./icon-edit@2x.png": "c387",
	"./icon-fankui.png": "af89",
	"./icon-home.png": "2fb9",
	"./icon-info.png": "c7eb",
	"./icon-look@2x.png": "4e65",
	"./icon-luti.png": "5a26",
	"./icon-pigai.png": "9388",
	"./icon-priview@2x.png": "6641",
	"./icon-school.png": "a346",
	"./icon-setting.png": "a18a",
	"./icon-tocollect1.png": "74e6",
	"./icon-upVideo@2x.png": "c73d",
	"./icon-weikeAdmin.png": "6285",
	"./icon-zujuan.png": "d2fa",
	"./icon-zujuan@2x.png": "fb55",
	"./icon-个人详细@2x.png": "ac87",
	"./icon-修改题目@2x.png": "2b51",
	"./icon-分组管理@2x.png": "36d8",
	"./icon-备课@2x.png": "bbc6",
	"./icon-学生弱点@2x.png": "d0b0",
	"./icon-审核@2x.png": "a49b",
	"./icon-录入@2x.png": "9636",
	"./icon-录题@2x.png": "641c",
	"./icon-我的@2x.png": "9e0b",
	"./icon-我的批改@2x.png": "e7f1",
	"./icon-批改试卷@2x.png": "9c8b",
	"./icon-教务@2x.png": "4ae7",
	"./icon-数据中心.png": "794d",
	"./icon-整卷出卷@2x.png": "e12c",
	"./icon-智能组卷@2x.png": "5b08",
	"./icon-校对@2x.png": "5264",
	"./icon-模板组卷.png": "c9a4",
	"./icon-答题卡.png": "07cd",
	"./icon-组卷统计@2x.png": "82ed",
	"./icon-统计信息@2x.png": "8649",
	"./icon-考试管理@2x.png": "65c5",
	"./icon-视频资源.png": "6c02",
	"./icon-讲义管理.png": "5506",
	"./icon-论坛@2x.png": "ee26",
	"./jiucuo.png": "8e81",
	"./redjiucuo.png": "3f88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";